import { FiPlusCircle, FiTrash2, FiX } from 'react-icons/fi'
import { Container } from './style'

type Props = {
    targetModalName: string
    className?: string
    type: 'create' | 'delete'
    title: string,
    escClick?: boolean,
    outsideClick?: boolean,
    showTopBtnclone?: boolean,
    hideFooter?: boolean,
    btnFirstText?: string,
    btnSecondText?: string,
    children: any,
    elemRef?: React.MutableRefObject<any>,
    confirmAction?: () => void
}

export const Modal = ({
    targetModalName,
    escClick,
    outsideClick,
    className,
    type,
    title,
    btnFirstText,
    btnSecondText,
    children,
    confirmAction,
    elemRef,
    hideFooter,
    showTopBtnclone
}: Props): JSX.Element => {
    return (
        <Container>
            <div
                className={`modal fade${className ? ' ' + className : ''}`}
                id={targetModalName}
                data-bs-backdrop={outsideClick ? undefined : 'static'}
                data-bs-keyboard={escClick || false}
                tabIndex={-1}
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
                ref={elemRef}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className={`modal-header${showTopBtnclone ? ' has-close' : ''}`}>
                            {!showTopBtnclone && (
                                <div className={`icon ${type}`}>
                                    {type === 'create' ? <FiPlusCircle size={28} /> : <FiTrash2 size={26} />}
                                </div>
                            )}
                            <h1 className="modal-title" id="staticBackdropLabel">{title}</h1>
                            {showTopBtnclone && (
                                <button
                                    type="button"
                                    className="btn-modal-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Fechar"
                                >
                                    <FiX size={22} />
                                </button>
                            )}
                        </div>

                        <div className="modal-body">
                            {children}
                        </div>

                        {!hideFooter &&
                            <div className="modal-footer">
                                <button type="button" className="btn-footer btn-first" data-bs-dismiss="modal">{btnFirstText || 'Cancelar'}</button>
                                <button type="button" className={`btn-footer btn-${type}`} onClick={confirmAction}>{btnSecondText}</button>
                            </div>}
                    </div>
                </div>
            </div>
        </Container>
    )
}
